
function scrollMouseani(){

  if($("body").hasClass("bc-1")){
    setTimeout(function(){
      $("body").prepend('<div class="scrollDownMouse" style="z-index:99; left:0; right:0; text-align:center; position:absolute; top:30vh; opacity:0;"><img alt="" src="fileadmin/all_user/img/start/scrolldown.png"/></div>');

      var mouseDiv = $(".scrollDownMouse");

      var topPos = 30;
      opacityVar = 0;

      actualAnimation();
      function actualAnimation(){
        if(topPos < 80){
          topPos += 0.5;
          if(topPos < 50){
            opacityVar += 0.05;
          };
          if(topPos > 55){
            opacityVar -= 0.05;
          };
          mouseDiv.css({"top":topPos+"vh","opacity":opacityVar});
          if(topPos >= 80){
            mouseDiv.remove();
          }
        }
        setTimeout(function(){
          actualAnimation();
        }, 10);
      }
    }, 800);
  }
}
/*
  for(topPos; topPos < 85; topPos +=0.1;){
    setTimeout(function(){
      console.log(topPos);
    }, 100);
  }
  */
